import React, { useEffect, useState } from "react";
// import UserForm from '../users/UserForm';
import { Col, Form, Input, Modal, Row, Select } from "antd";
import UserServices from "../../services/UserServices";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { usePersistedStore } from "../../store/persisted-store";
import OnlyNumber from "../shared/OnlyNumbers";
import strings from "../../utils/strings";
import moment from "moment-jalaali";

const EditMarketer = ({
  showModal,
  getMarketersList,
  setShowModal,
  closeModal,
  selectedMarketer,
  setSelectedMarketer,
}) => {
  const general = useGeneralStore();
  const [form] = Form.useForm();
  const [provincesLoaded, setProvincesLoaded] = useState(false);
  const [currentProvince, setCurrentProvince] = useState(null);
  const {
    business,
    marketers,
    FILTERED_ITEM,
    FILTER_USERS,
    auth,
    GET_ALL_USERS,
    SET_TOTAL_USERS,
    Marketers_LOADING,
  } = usePersistedStore();
  // const general = useGeneralStore();
  const MarketersData = marketers.data;
  const userToken = auth?.userToken;
  const provinces = general.provinces.data.Provinces;
  const cities = general.cities.data.Cities;
  const roleList = business.businesses.roles.Roles;
  const currentBusiness = business?.currentBusiness;

  const [marketerLoading, setMarketerLoading] = useState(false);
  const { token } = currentBusiness;
  useEffect(() => {
    if (!provincesLoaded) {
      general.getProvinces();
      setProvincesLoaded(true);
    }
    // `general` is a whole-store reference that changes identity on every
    // store update; only `provincesLoaded` should gate this fetch.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provincesLoaded]);

  const handleCancel = () => {
    // setIsModalVisible(false);
    form.resetFields(); // ریست کردن فرم
  };

  const formLayout = {
    labelCol: {
      lg: 7,
      xs: 24,
    },
    wrapperCol: {
      lg: 15,
      xs: 24,
    },
  };
  const itemLayout = {
    lg: 12,
    md: 12,
    sm: 24,
    xs: 24,
  };

  useEffect(() => {
    // general.getProvinces();
    loadProvince();
  }, [form, selectedMarketer]);

  const loadProvince = () => {
    if (provinces) {
      const currentProvinceTemp = provinces.find(
        (item) => item.Title === selectedMarketer?.ProvinceName
      );
      setCurrentProvince(currentProvinceTemp);
      form.setFieldsValue({ ProvinceId: currentProvinceTemp?.Id });
      // values.ProvinceId = currentProvinceTemp?.Id
      if (currentProvinceTemp && currentProvinceTemp?.Id)
        general.getCities(currentProvinceTemp?.Id);
    }
  };

  useEffect(() => {
    // general.getProvinces();
    if(cities){
      const currentCitiesTemp = cities.find(
        (item) => item.Title === selectedMarketer?.CityName
      );
      // setCurrentProvince(currentProvinceTemp);
      form.setFieldsValue({ CityId: currentCitiesTemp?.Id });
    }
  }, [form, cities]);

  const onSubmit = () => {
    setShowModal(false);
    closeModal();
    setCurrentProvince(null);
    setSelectedMarketer(null)
    getMarketersList()
    general.NotifSuccess("اطلاعات بازاریاب با موفقیت بروزرسانی شد");
  };
  function onFinish(values) {
    if (!values.ProvinceId || !values.CityId)
      general.NotifError("شهر را انتخاب کنید");
    else if (!values.JobTitle) {
      general.NotifError("شغل را وارد کنید");
    } else {
      setMarketerLoading(true);
      UserServices.updateMarketerInfo(
        {
          // PersonId: values.PersonId,
          JobTitle: values.JobTitle,
          CityId: values.CityId,
        },
        userToken,
        token
      )
        .then((res) => {
          onSubmit();
          form.resetFields();
          // getUsersPerPage();
          setMarketerLoading(false);
        })
        .catch((error) => {
          form.resetFields();
          setMarketerLoading(false);
        });
    }
  }

  return (
    <Modal
      width={800}
      className="custom-table"
      title="بروزرسانی اطللاعات بازاریاب"
      visible={showModal}
      footer={false}
      onCancel={() => {
        setShowModal(false);
        closeModal();
        form.resetFields();
        handleCancel();
        setSelectedMarketer(null)
        setCurrentProvince(null);
      }}
    >
      {/* <MarketerForm
        onSubmit={() => {
          setShowModal(false);
          setCurrentProvince(null);
          general.NotifSuccess("اطلاعات بازاریاب با موفقیت بروزرسانی شد");
        }}
        marketer={selectedMarketer}
        setSelectedMarketer={setSelectedMarketer}
        formType={true}
        currentProvince={currentProvince}
        setCurrentProvince={setCurrentProvince}
        // pageNumber={pageNumber}
        // pageSize={pageSize}
      /> */}
      <Form
        form={form}
        name="user-form"
        className="business-form"
        {...formLayout}
        initialValues={{
          FullName: selectedMarketer?.FullName,
          Username: selectedMarketer?.Username,
          // PersonId: selectedMarketer?.PersonId,
          ProvinceId: currentProvince?.Id,
          JobTitle: selectedMarketer?.JobTitle,
          // CreateAt: strings.getFarsiNum(
          //   moment(selectedMarketer?.CreationTime).format(
          //     " jYYYY/jMM/jDD  ساعت:  HH:mm "
          //   )
          // ),
        }}
        onFinish={onFinish}
        autoComplete="off"
        onSubmit={() => {
          setShowModal(false);
          setCurrentProvince(null);
          general.NotifSuccess("اطلاعات بازاریاب با موفقیت بروزرسانی شد");
        }}
      >
        <Row>
          <Col {...itemLayout}>
            <Form.Item name="Username" label="نام کاربری">
              <Input readOnly disabled/>
            </Form.Item>
          </Col>
          <Col {...itemLayout}>
            <Form.Item name="FullName" label="نام کاربر">
              <Input readOnly disabled/>
            </Form.Item>
          </Col>

          {/* <Col {...itemLayout}>
            <Form.Item
              // rules={ValidatorHelper._farsi("نام پدر")}
              name="PersonId"
              label="شماره پرسنلی"
            >
              <Input readOnly />
            </Form.Item>
          </Col> */}
          {/* <Col {...itemLayout}>
            <Form.Item
              onKeyPress={(e) => OnlyNumber(e)}
              name="CreateAt"
              label="تاریخ درخواست"
            >
              <Input readOnly />
            </Form.Item>
          </Col> */}

          <Col {...itemLayout}>
            <Form.Item name="ProvinceId" label="استان">
              <Select
                onChange={(provinceId) => {
                  general.getCities(provinceId);
                }}
              >
                {provinces &&
                  provinces.map((province) => (
                    <Select.Option key={`province_${province.Id}`} value={province.Id}>
                      {province.Title}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col {...itemLayout}>
            <Form.Item name="CityId" label="شهر">
              <Select disabled={cities === undefined || cities.length === 0}>
                {cities &&
                  cities.map((city) => (
                    <Select.Option key={`city_${city.Id}`} value={city.Id}>
                      {city.Title}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          <Col {...itemLayout}>
            <Form.Item
              // rules={ValidatorHelper.firstname()}
              // onKeyPress={e => OnlyNumber(e)}
              name="JobTitle"
              label="شغل"
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <button
          type="primary"
          className="btn btn-primary waves-effect waves-light"
          htmltype="submit"
          style={{ width: "100%" }}
        >
          <i
            className={`${
              marketerLoading ? "bx bx-loader bx-spin" : "bx bx-check-double"
            } "font-size-14 align-middle mr-2 ml-3"`}
          ></i>
          ثبت
        </button>
      </Form>
    </Modal>
  );
};

export default EditMarketer;
